import 'core-js/modules/es.array.flat';
import 'core-js/modules/es.array.flat-map';
import { createApp } from 'vue';
import moment from 'moment';
import AMapLoader from '@amap/amap-jsapi-loader';
import Validator from 'async-validator';
import 'vue2-animate/dist/vue2-animate.min.css';

import touch from 'vue3-hand-mobile';

import { ImagePreview, Uploader, Swipe, SwipeItem, Button, Lazyload, Col, Divider, Dialog, Image as VanImage, Loading, Popup, List, Notify, Toast, Picker, DatePicker, Cell, CellGroup, Field, Checkbox, RadioGroup, Radio, Cascader, Area } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/image-preview/style';
import 'vant/es/notify/style';
import 'vant/es/dialog/style';

import icons from '@/icons'; // icon

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import Components from './components';
import Mixins from './mixins';
import http from './api/http';
import { queryParse } from 'cfmoto-utils';

if (window.VConsole) {
  const vConsole = new window.VConsole({ maxLogNumber: 1000 });
  console.log(vConsole);
  console.log('打印======');
  console.log('window.cfmoto:');
  console.log(window.cfmoto);
  console.log('window.native:');
  console.log(window.native);
  console.log('window.android:');
  console.log(window.android);
}
import '@vant/touch-emulator';

http.router = router;
http.store = store;

AMapLoader.load({
  key: '5c13a279fa4bc31e4886e082c7ec3563',
  plugins: [
    'Autocomplete',
    'PlaceSearch',
    'AMap.MouseTool',
    'OverView',
    'MapType',
    'PolyEditor',
    'AMap.CircleEditor',
    'AMap.MarkerCluster',
    'AMap.Geocoder',
    'AMap.Geolocation',
    'AMap.Rectangle',
    'Scale',
    'OverView',
    'ToolBar',
    'MapType',
    'Marker',
    'AMap.MoveAnimation',
  ],
  version: '2.0',
  AMapUI: {
    // 是否加载 AMapUI，缺省不加载
    version: '1.1', // AMapUI 缺省 1.1
    plugins: [], // 需要加载的 AMapUI ui插件
  },
});

moment.locale();

const app = createApp(App);

const token = queryParse(window.location.search).token;
if ((app.isMiniapp || app.isApp) && (!token || /null/.test(token))) {
  localStorage.removeItem('token');
}

window.app = app;
window.audio = new Audio();
window.audio.loop = true;
app.config.globalProperties.$moment = moment;
app.config.productionTip = false;
app.config.globalProperties.$audio = window.audio;
app.config.globalProperties.$Validator = Validator;
app.use(touch);
app.use(Mixins).use(icons).use(Components);
app
  .use(Button)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(Col)
  .use(Divider)
  .use(Dialog)
  .use(VanImage)
  .use(Loading)
  .use(Popup)
  .use(List)
  .use(Toast)
  .use(Notify)
  .use(Picker)
  .use(Uploader)
  .use(ImagePreview)
  .use(DatePicker)
  .use(Cell)
  .use(CellGroup)
  .use(Field)
  .use(Checkbox)
  .use(RadioGroup)
  .use(Radio)
  .use(Cascader)
  .use(Area);
app.use(store).use(router).mount('#app');

document.addEventListener(
  'WeixinJSBridgeReady',
  function () {
    window.audio.loop = true;
    window.audio.autoplay = true;
    window.audio.play();
  },
  false
);
// localStorage.removeItem('token');
localStorage.removeItem('userId');
